import * as yup from 'yup';

export const validationSchema = yup.object({
    productId: yup.string().required("Required"),
    supplierId: yup.string().required("Required"),
    quantityInStock: yup.number().typeError("Must be a valid number").required("Required"),
    purchasePrice: yup.number().typeError("Must be a valid number").required("Required"),
    sellingPrice: yup.number().typeError("Must be a valid number").required("Required"),

})